export default __webpack_public_path__ + "static/media/illus.fa1ab603.png";